import { render, staticRenderFns } from "./ClientRow.vue?vue&type=template&id=73d6481d&"
import script from "./ClientRow.vue?vue&type=script&lang=js&"
export * from "./ClientRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports